import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import "./App.scss";
import Draw from "./pages/Draw";
import Create from "./pages/Create";
import Record from "./pages/Record";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Create />} />
        <Route path="/draw/:title" element={<Draw />} />
        <Route path="/record/:title" element={<Record />} />
        {/* <Route path="/previous" element={<Previous />} /> */}
        <Route path="/previous/:id" element={<Record />} />
      </Routes>
    </Router>
  );
};

export default App;
